/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrganization400Response,
  GetLegalEntityAvailableTypes200ResponseInner,
  GetLegalEntityCertificate200Response,
  GetLegalEntityCertificate404Response,
} from '../models/index';
import {
    CreateOrganization400ResponseFromJSON,
    CreateOrganization400ResponseToJSON,
    GetLegalEntityAvailableTypes200ResponseInnerFromJSON,
    GetLegalEntityAvailableTypes200ResponseInnerToJSON,
    GetLegalEntityCertificate200ResponseFromJSON,
    GetLegalEntityCertificate200ResponseToJSON,
    GetLegalEntityCertificate404ResponseFromJSON,
    GetLegalEntityCertificate404ResponseToJSON,
} from '../models/index';

export interface DeleteLegalEntityCertificateRequest {
    legalEntityId: string;
}

export interface GetLegalEntityAvailableTypesRequest {
    legalEntityId: string;
}

export interface GetLegalEntityAvailableTypesByCountryCodeRequest {
    countryCode: string;
}

export interface GetLegalEntityCertificateRequest {
    legalEntityId: string;
}

export interface UploadLegalEntityCertificateRequest {
    legalEntityId: string;
}

/**
 * 
 */
export class LegalEntitiesApi extends runtime.BaseAPI {

    /**
     */
    async deleteLegalEntityCertificateRaw(requestParameters: DeleteLegalEntityCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling deleteLegalEntityCertificate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/{legalEntityId}/certificates`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteLegalEntityCertificate(requestParameters: DeleteLegalEntityCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLegalEntityCertificateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getLegalEntityAvailableTypesRaw(requestParameters: GetLegalEntityAvailableTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetLegalEntityAvailableTypes200ResponseInner>>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling getLegalEntityAvailableTypes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/{legalEntityId}/available-types`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetLegalEntityAvailableTypes200ResponseInnerFromJSON));
    }

    /**
     */
    async getLegalEntityAvailableTypes(requestParameters: GetLegalEntityAvailableTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetLegalEntityAvailableTypes200ResponseInner>> {
        const response = await this.getLegalEntityAvailableTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLegalEntityAvailableTypesByCountryCodeRaw(requestParameters: GetLegalEntityAvailableTypesByCountryCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetLegalEntityAvailableTypes200ResponseInner>>> {
        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling getLegalEntityAvailableTypesByCountryCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/available-types/{countryCode}`.replace(`{${"countryCode"}}`, encodeURIComponent(String(requestParameters['countryCode']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetLegalEntityAvailableTypes200ResponseInnerFromJSON));
    }

    /**
     */
    async getLegalEntityAvailableTypesByCountryCode(requestParameters: GetLegalEntityAvailableTypesByCountryCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetLegalEntityAvailableTypes200ResponseInner>> {
        const response = await this.getLegalEntityAvailableTypesByCountryCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLegalEntityCertificateRaw(requestParameters: GetLegalEntityCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLegalEntityCertificate200Response>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling getLegalEntityCertificate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/{legalEntityId}/certificates`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLegalEntityCertificate200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLegalEntityCertificate(requestParameters: GetLegalEntityCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLegalEntityCertificate200Response> {
        const response = await this.getLegalEntityCertificateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadLegalEntityCertificateRaw(requestParameters: UploadLegalEntityCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLegalEntityCertificate200Response>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling uploadLegalEntityCertificate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/{legalEntityId}/certificates`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLegalEntityCertificate200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadLegalEntityCertificate(requestParameters: UploadLegalEntityCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLegalEntityCertificate200Response> {
        const response = await this.uploadLegalEntityCertificateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
